import { defineComponent as _defineComponent } from 'vue'
import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import VideoPlayer from '@/components/VideoPlayer.vue'
  import useCourse from '@/composables/useCourse'
  import useVideo from '@/composables/useVideo'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import type { PropType } from 'vue'
  import type { Webinar } from '@/services/interfaces/Course'
  import useShopifyClient from '@/composables/useShopifyClient'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WebinarModal',
  props: {
    webinar: {
      type: Object as PropType<Webinar>,
      required: true,
    },
    purchasedCourse: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

  
  
  const { currentCourseId } = useCourse()
  const { getPosterImage } = useVideo()
  const { createShopifyCheckout } = useShopifyClient()
  const { windowOpenProxyCheck } = useCommonMixin()

  const openBooking = async () => {
    if (props.purchasedCourse) {
      windowOpenProxyCheck(props.webinar.bookingUrl, 'webinar')
    } else {
      emit('close')
      await createShopifyCheckout()
    }
  }

return { __sfc: true,props, emit, currentCourseId, getPosterImage, createShopifyCheckout, windowOpenProxyCheck, openBooking, HTMLRenderer, VideoPlayer, useCourse, useVideo, KetchUpButton, useShopifyClient, useCommonMixin }
}

})